import { useState } from 'react'

export const useSnackbar = () => {
    const [open, setOpen] = useState(false)

    const handleOpen = () => {
        setOpen(true)
    }

    const handleClose = (_event?: React.SyntheticEvent, reason?: string) => {
        if (reason === 'clickaway') {
            return
        }

        setOpen(false)
    }

    return { open, openSnackbar: handleOpen, closeSnackbar: handleClose }
}
